import { Res } from 'core/api';
import { Currency } from 'core/utils';

export type Constraint = (value: any) => string;

export function check(constraints: Constraint | Constraint[], value: any): string {

	const isSingle = function (f: any): f is Constraint {
		return typeof f === 'function';
	};

	let validations: Constraint[] = [];

	if (isSingle(constraints)) {
		validations.push(constraints);
	}
	else {
		validations = constraints;
	}
	return validations.map(f => f(value)).filter(x => !!x).join(' ');
}

export function maxLength(length: number): Constraint {
	return function (value: string) {
		return (value || '').toString().length <= length ? '' : Res.Msg.MSG_MAX_LENGTH_IS_N_CHARS(length);
	};
}

export function minLength(length: number): Constraint {
	return function (value: string) {
		return (value || '').toString().length >= length ? '' : Res.Msg.MSG_MIN_LENGTH_IS_N_CHARS(length);
	};
}

export function match(pattern: RegExp, msg = ''): Constraint {

	msg = msg || Res.Msg.MSG_INVALID_FORMAT();

	return function (value: string) {
		return pattern.test(value) ? '' : msg;
	};
}

export function range(from: number, to: number): Constraint {
	return function (value: number) {
		return from <= value && value <= to ? '' : Res.Msg.MSG_VALUE_IS_OUT_OF_RANGE(from, to);
	};
}

export function price(value?: number): string {
	if (typeof value === 'undefined')
		return '';

	return check([positive, maxDecimalPlaces(Currency.DECIMAL_PLACES)], value);
}

export function positive(value: number): string {
	return value >= 0 ? '' : Res.Msg.MSG_VALUE_MUST_BE_POSITIVE();
}

export function negative(value: number): string {
	return value <= 0 ? '' : Res.Msg.MSG_VALUE_MUST_BE_NEGATIVE();
}

export function isNotZero(value: number): string {
	return value !== 0 ? '' : Res.Msg.MSG_VALUE_CANNOT_BE_ZERO();
}

export function greaterThanZero(value: number): string {
	return value > 0 ? '' : Res.Msg.MSG_VALUE_MUST_BE_GREATER_THAN_ZERO();
}

function getDecimalPlaces(value: number) {
	if (!value)
		return 0;

	const str = value.toLocaleString(navigator.language, { maximumFractionDigits: 20, useGrouping: false });
	const separatorIndex = str.indexOf(Currency.DECIMAL_SEPARATOR);
	if (separatorIndex === -1)
		return 0;
	return str.length - (separatorIndex + 1);
}

export function maxDecimalPlaces(places: number): Constraint {
	return function (value: number) {
		return getDecimalPlaces(value) > places ? Res.Msg.MSG_VALUE_MUST_HAVE_AT_MOST_N_DIGITAL_PLACES(places) : '';
	};
}
